import React, { useEffect, useState } from "react";
import { Paper } from "@mui/material";
import { HorizontalFormStepper } from "../../../utils/formUtils";
import AddHospitalDetails from "../addcases/AddHospitalDetails";
import EditStatusModal from "./EditStatusModal";
import SecondStageApproval from "./SecondStageApproval";
import EditStatusClaimModal from "./EditStatusClaimModal";
import MoveToNextStage from "./MoveToNextStage";
import AddPatientDetails from "../addcases/AddPatientDetails";
import AddCaseDetails from "../addcases/AddCaseDetails";
import MapDocumentsNewPage from "../mapdocuments/MapDocumentsNewPage";
import AddDocuments from "../addcases/AddDocuments";
import AddEnhancement from "../addEnhancement/AddEnhancement";
import AddDischarge from "../addDischarge/AddDischarge";
import CaseHistory from "../casehistory/CaseHistory";
import NewDutAccordion from "../../../NewDutFlow/NewDutAccordion";
import { CircularProgress } from "@mui/material";
import DownloadDocuments from "../downloadDocuments/DownloadDocuments";
import TabStepperUtil from "../../../utils/tabStepperUtil";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import EditIcon from "../../../assets/editIconWhite.svg";
import DownArrow from "../../../assets/downArrowIcon.svg";
import "./EditCasesDashboard.scss";
import { CaseServices } from "../../../services/CaseServices";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { CaseContext } from "../contexts/CaseContexts";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { useSelector, useDispatch } from "react-redux";
import { setOutsideUser } from "../../../redux/roleSlice";
import TmsQueries from "../TmsQueries";
import PatientInfo from "./PatientInfo";
import AiReviewTab from "./AiReviewTab";
let componentWithoutPage = ["MAP DOCUMENTS", "CASE HISTORY"];
const steps = [
  "Initiate Admission",
  "Admission Approved",
  "Enhancement Initiated",
  "Enhancement Approved",
  "Discharge Initiated",
  "Claim Initiated",
  "Claim Approved",
];

const EditCasesDashboard = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [notificationCaseId, setNotificationCaseId] = useState(
    searchParams.get("caseId"),
  );
  const selectedTab = useSelector((state) => state.currentRole.selectedTab);
  const [value, setValue] = React.useState(
    location?.state?.tab || selectedTab || "HOSPITAL DETAILS",
  );
  const [caseId, setCaseId] = useState(
    searchParams.get("caseId")
      ? searchParams.get("caseId")
      : location?.state?.selectedCase?.id,
  );
  const [patientId, setPatientId] = useState("");
  const [caseDetails, setCaseDetails] = useState(null);
  const [hospitalid, sethospitalid] = useState("");
  const [patientDetails, setPatientDetails] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [editStatus, setEditStatus] = useState(false);
  const [moveToNextStage, setNextStage] = useState(false);
  const [secondStageApproval, setSecondStageApproval] = useState(false);
  const currentRole = useSelector((state) => state.currentRole.value);

  async function refreshPage() {
    setLoading(true);
    try {
      let res = await CaseServices.getCaseDetails(caseId);
      if (res?.data?.caseDetails) {
        setCaseDetails(res?.data?.caseDetails);
        sethospitalid(res?.data?.caseDetails?.hospitalId);
        setPatientDetails(res?.data?.caseDetails?.patient);
        setPatientId(res?.data?.caseDetails?.patientId);
        setActiveStep(
          res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
            .toLowerCase()
            .includes("admission") &&
            !res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
              .toLowerCase()
              .includes("approved on tms")
            ? 0
            : res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
                  .toLowerCase()
                  .includes("admission approved on tms")
              ? 1
              : res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
                    .toLowerCase()
                    .includes("enhancement") &&
                  !res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
                    .toLowerCase()
                    .includes("approved on tms")
                ? 2
                : res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
                      .toLowerCase()
                      .includes("enhancement approved on tms")
                  ? 3
                  : res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
                        .toLowerCase()
                        .includes("claim") &&
                      !res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
                        .toLowerCase()
                        .includes("paid")
                    ? 5
                    : res?.data?.caseDetails?.submasterstagestatuses[0]?.hsaStage
                          .toLowerCase()
                          .includes("claim paid")
                      ? 6
                      : -1,
        );
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  }
  useEffect(() => {
    if (notificationCaseId) {
      refreshPage();
    }
  }, [notificationCaseId]);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    refreshPage();
  }, []);

  const isTpa = caseDetails?.isTpa === true;
  // const tpaHiddenTabs = ["CASE DETAILS", "MAP DOCUMENTS", "ENHANCEMENT MAPPING"];
  const tpaHiddenTabs = ["CASE DETAILS", "MAP DOCUMENTS"];

  const showEnhancementTabs =
    caseDetails?.submasterstagestatuses[0]?.hsaStage
      ?.toLowerCase()
      .includes("enhancement approved on tms") ||
    caseDetails?.submasterstagestatuses[0]?.commandCenterStage
      ?.toLowerCase()
      .includes("request to add new enhancement procedure") ||
    caseDetails?.submasterstagestatuses[0]?.hsaStage
      ?.toLowerCase()
      .includes("admission approved on tms") ||
    caseDetails?.submasterstagestatuses[0]?.hsaStage
      ?.toLowerCase()
      .includes("enhancement rejected");

  const hospitalTab = {
    label: "HOSPITAL DETAILS",
    child: (
      <AddHospitalDetails
        refreshPage={refreshPage}
        setValue={setValue}
        hospitalDetails={caseDetails?.hospital}
        setCaseId={setCaseId}
        sethospitalid={sethospitalid}
        caseId={caseId}
        functionalityType="EDIT"
      />
    ),
  };
  const patientTab = {
    label: "PATIENT DETAILS",
    child: (
      <AddPatientDetails
        refreshPage={refreshPage}
        setValue={setValue}
        patientDetails={caseDetails?.patient}
        registrationId={caseDetails?.pmjayRegistrationId}
        carePlan={caseDetails?.carePlan}
        setCaseId={setCaseId}
        setPatientId={setPatientId}
        hospitalid={hospitalid}
        functionalityType="EDIT"
      />
    ),
  };
  const caseDetailsTab = {
    label: "CASE DETAILS",
    child: (
      <AddCaseDetails
        refreshPage={refreshPage}
        setValue={setValue}
        setCaseId={setCaseId}
        patientId={patientId}
        setPatientId={setPatientId}
        caseDetails={caseDetails}
        patientDetails={patientDetails}
        setPatientDetails={setPatientDetails}
        functionalityType="EDIT"
      />
    ),
  };
  const enhancementTab = {
    label: "ENHANCEMENT",
    child: <AddEnhancement caseDetails={caseDetails} setValue={setValue} />,
  };
  const dischargeTab = {
    label: "DISCHARGE",
    child: <AddDischarge caseDetails={caseDetails} setValue={setValue} />,
  };
  const mapDocumentsTab = {
    label: "MAP DOCUMENTS",
    child: (
      <MapDocumentsNewPage
        refreshPage={refreshPage}
        setValue={setValue}
        setCaseId={setCaseId}
        hsaStage={caseDetails?.submasterstagestatuses[0]?.hsaStage}
        csProcedures={caseDetails?.caseprocedures}
        caseId={caseId}
        functionalityType="EDIT"
        caseType={caseDetails?.caseType}
        caseStage={caseDetails?.submasterstagestatuses[0]?.commandCenterStage}
      />
    ),
  };
  const updateDocumentsTab = {
    label: "UPDATE DOCUMENTS",
    child: (
      <AddDocuments
        caseId={caseId}
        hsaStage={caseDetails?.submasterstagestatuses[0]?.hsaStage}
        functionalityType="EDIT"
        payer={caseDetails?.payer}
        refreshPage={refreshPage}
        isTpa={isTpa}
        onOpenSecondStageApproval={() => setSecondStageApproval(true)}
      />
    ),
  };
  const enhancementMappingTab = {
    label: "ENHANCEMENT MAPPING",
    child: <CaseHistory functionalityType="EDIT" caseDetails={caseDetails} />,
  };
  const downloadDocumentsTab = {
    label: "DOWNLOAD DOCUMENTS",
    child: (
      <DownloadDocuments
        caseId={caseId}
        patientName={caseDetails?.patient?.patientName}
        hospitalName={caseDetails?.hospital?.name}
        registrationId={caseDetails?.pmjayRegistrationId}
        tmsVersion={caseDetails?.hospital?.tmsVersion}
      />
    ),
  };
  const aiReviewTab = caseDetails?.caseprocedures?.[0]?.doctorDetails
    ? {
        label: "AI Review",
        child: <AiReviewTab selectedCase={caseDetails} />,
      }
    : null;

  let tabItems = [hospitalTab, patientTab];
  if (
    (caseDetails &&
      caseDetails.masterstagestatuses &&
      caseDetails.masterstagestatuses[0]?.masterStageStatus === "ACTIVE") ||
    caseDetails?.status === "ACTIVE" ||
    caseDetails?.status?.toLowerCase().includes("complete")
  ) {
    if (
      caseDetails &&
      ((caseDetails.caseprocedures && caseDetails.caseprocedures.length > 0) ||
        isTpa)
    ) {
      tabItems = showEnhancementTabs
        ? [
            hospitalTab,
            patientTab,
            caseDetailsTab,
            enhancementTab,
            dischargeTab,
            mapDocumentsTab,
            updateDocumentsTab,
            enhancementMappingTab,
            downloadDocumentsTab,
            aiReviewTab,
          ].filter(Boolean)
        : [
            hospitalTab,
            patientTab,
            caseDetailsTab,
            dischargeTab,
            mapDocumentsTab,
            updateDocumentsTab,
            enhancementMappingTab,
            downloadDocumentsTab,
            aiReviewTab,
          ].filter(Boolean);
    } else {
      tabItems = [hospitalTab, patientTab, caseDetailsTab];
    }
  }

  if (isTpa) {
    tabItems = tabItems.filter((tab) => !tpaHiddenTabs.includes(tab.label));
  }

  const labels = tabItems.map((tab) => tab.label);
  const children = tabItems.map((tab) => tab.child);

  useEffect(() => {
    if (!isTpa || !tpaHiddenTabs.includes(value)) return;
    setValue(
      labels.includes("UPDATE DOCUMENTS")
        ? "UPDATE DOCUMENTS"
        : "HOSPITAL DETAILS",
    );
  }, [isTpa, value, caseDetails?.id]);

  dispatch(setOutsideUser(false)); // removed outside user value from store
  console.log("caseDetails:", caseDetails);

  return (
    <div className="edit-case-dashboard">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; EditCases
      </span>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="heading">Edit Cases</div>
        {currentRole?.roleId !== 1 && currentRole?.roleId !== 2 && (
          <div className="flex gap-2">
            <div
              className="text-sm text-white font-semibold bg-[#017C57] px-4 py-2 rounded-full cursor-pointer"
              onClick={() => setNextStage(true)}
            >
              Move To Next Stage
            </div>
            {currentRole?.role?.roleName === "TeamA" ? (
              <div className="flex gap-4">
                <div>
                  {" "}
                  <select
                    name=""
                    id=""
                    style={{ border: "1px solid #017C57" }}
                    className="px-4 py-2 text-[#017C57] text-sm font-semibold rounded-full"
                  >
                    <option value="">
                      ASSIGN MANAGER
                      <span>
                        <img src={DownArrow} alt="down-arrow-icon" />
                      </span>
                    </option>
                    <option value="">MANAGER 1</option>
                    <option value="">MANAGER 2</option>
                    <option value="">MANAGER 3</option>
                  </select>
                </div>
              </div>
            ) : (
              <div
                style={{
                  background: "#017C57",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "600",
                  paddingBlock: "8px",
                  paddingInline: "16px",
                  borderRadius: "32px",
                  display: "flex",
                  gap: "12px",
                  cursor: "pointer",
                  textWrap: "nowrap",
                }}
                onClick={() => setEditStatus(true)}
              >
                <img src={EditIcon} alt="edit-icon" />
                Edit Status / Map Query
              </div>
            )}
            {!isTpa && (
              <div
                className="text-sm text-white font-semibold bg-[#017C57] px-4 py-2 rounded-full cursor-pointer"
                onClick={() => setSecondStageApproval(true)}
              >
                Second Stage Approval
              </div>
            )}
            {moveToNextStage && (
              <MoveToNextStage setNextStage={setNextStage} caseId={caseId} />
            )}
            {editStatus && (
              <div
                style={{
                  position: "fixed",
                  top: "0",
                  left: "0",
                  height: "100vh",
                  width: "100vw",
                  background: "#017C5780",
                  zIndex: "1203",
                  overflowY: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {caseDetails?.submasterstagestatuses[0]?.commandCenterStage
                  .toLowerCase()
                  .includes("claim sent to bank on tms") ? (
                  <EditStatusClaimModal
                    setEditStatus={setEditStatus}
                    caseId={caseId}
                    caseDetails={caseDetails}
                  />
                ) : (
                  // <EditStatusModal
                  //   setEditStatus={setEditStatus}
                  //   caseId={caseId}
                  // />

                  <div className="relative w-[95%] h-[95%] rounded-[32px] bg-white p-6 overflow-hidden">
                    <TmsQueries
                      caseId={caseId}
                      setEditStatus={setEditStatus}
                      onCloseModal={() => setEditStatus(false)}
                      showClose={true}
                    />
                  </div>
                )}
              </div>
            )}
            {secondStageApproval && (
              <CaseContext.Provider
                value={{
                  roleName: currentRole?.role?.roleName,
                  getCaseDetails: refreshPage,
                }}
              >
                <SecondStageApproval
                  setSecondStageApproval={setSecondStageApproval}
                  caseId={caseId}
                  caseDetails={caseDetails}
                />
              </CaseContext.Provider>
            )}
          </div>
        )}
      </div>
      <hr
        style={{
          color: "#E7E7E7",
          marginBottom: "20px",
        }}
      />
      <Paper className="stepper-box">
        <HorizontalFormStepper steps={steps} activeStep={activeStep} />
      </Paper>

      {value != "CASE DETAILS" && (
        <PatientInfo
          caseDetails={caseDetails}
          patientDetails={caseDetails?.patient}
        />
      )}
      {loading ? (
        <div className="flex justify-center items-center mt-5">
          <CircularProgress />
        </div>
      ) : (
        <CaseContext.Provider
          value={{
            roleName: currentRole?.role?.roleName,
            tmsVersion: caseDetails?.hospital?.tmsVersion,
            patientDetails: patientDetails,
            registrationId: caseDetails?.pmjayRegistrationId,
            refreshFunction: refreshPage,
            caseDetails: caseDetails,
            getCaseDetails: refreshPage,
          }}
        >
          <TabStepperUtil
            children={children}
            labels={labels}
            value={value}
            setValue={setValue}
            componentWithoutPage={componentWithoutPage}
            handleChageDisabled="false"
          />
        </CaseContext.Provider>
      )}
      {/* <PhoneSupport /> */}
    </div>
  );
};

export default EditCasesDashboard;
